import React, { useMemo } from "react";

export default function AdminHomeScreen({
  goBack,
  role,
  onOpenProducts,
  onOpenUsers,
  onOpenSupport,
  onOpenReports,
  onOpenNotifications,
  onOpenPayments, // ✅ ADD
}) {
  const roleLower = String(role || "").toLowerCase();
  const isWorker = roleLower === "worker";
  const isAdmin = roleLower === "admin";

  const subtitle = useMemo(() => {
    if (isAdmin) return "Full access: moderation, users, support, reports.";
    if (isWorker) return "Limited access: moderation + support + reports.";
    return "No access.";
  }, [isAdmin, isWorker]);

  return (
    <div style={S.page}>
      <div style={S.top}>
        <button style={S.back} onClick={goBack}>
          ←
        </button>
        <div>
          <div style={S.h1}>Admin Panel</div>
          <div style={S.sub}>{subtitle}</div>
        </div>
        <div style={{ marginLeft: "auto" }}>
          <span style={S.badge}>{roleLower || "user"}</span>
        </div>
      </div>

      <div style={S.grid}>
        <button style={S.card} onClick={onOpenProducts}>
          <div style={S.icon}>✅</div>
          <div style={S.cardTitle}>Product Approvals</div>
          <div style={S.cardSub}>Approve / Reject / Hide</div>
        </button>

        <button style={S.card} onClick={onOpenNotifications}>
          <div style={S.icon}>🔔</div>
          <div style={S.cardTitle}>Notifications</div>
          <div style={S.cardSub}>Send to user / broadcast</div>
        </button>

        <button style={S.card} onClick={onOpenSupport}>
          <div style={S.icon}>💬</div>
          <div style={S.cardTitle}>Support Inbox</div>
          <div style={S.cardSub}>Reply tickets fast</div>
        </button>

        <button style={S.card} onClick={onOpenReports}>
          <div style={S.icon}>🚩</div>
          <div style={S.cardTitle}>Reports</div>
          <div style={S.cardSub}>Review user reports</div>
        </button>

        {/* ✅ PAYMENTS (Admin only like Users) */}
        <button
          style={{ ...S.card, opacity: isAdmin ? 1 : 0.55 }}
          onClick={() => (isAdmin ? onOpenPayments?.() : null)}
          title={isAdmin ? "" : "Admins only"}
        >
          <div style={S.icon}>💳</div>
          <div style={S.cardTitle}>Payments</div>
          <div style={S.cardSub}>Confirm seller payments</div>
          {!isAdmin && <div style={S.lock}>Admin only</div>}
        </button>

        <button
          style={{ ...S.card, opacity: isAdmin ? 1 : 0.55 }}
          onClick={() => (isAdmin ? onOpenUsers() : null)}
          title={isAdmin ? "" : "Admins only"}
        >
          <div style={S.icon}>🧑‍⚖️</div>
          <div style={S.cardTitle}>Users & Roles</div>
          <div style={S.cardSub}>Ban / Unban / Promote</div>
          {!isAdmin && <div style={S.lock}>Admin only</div>}
        </button>
      </div>

      <div style={S.note}>
        Tip: In Firestore set <b>stores/{`{uid}`}.role</b> to{" "}
        <code>admin</code> or <code>worker</code>.
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: "100vh",
    padding: 14,
    background: "linear-gradient(180deg,#f7f8ff 0%,#eef2ff 45%,#f8fafc 100%)",
  },
  top: {
    maxWidth: 980,
    margin: "0 auto 14px",
    display: "flex",
    gap: 12,
    alignItems: "center",
  },
  back: {
    width: 42,
    height: 42,
    borderRadius: 14,
    border: "1px solid rgba(15,23,42,0.10)",
    background: "white",
    cursor: "pointer",
    fontWeight: 900,
  },
  h1: { fontSize: 18, fontWeight: 950, color: "#0f172a" },
  sub: {
    marginTop: 2,
    fontSize: 12,
    fontWeight: 800,
    color: "rgba(15,23,42,0.60)",
  },
  badge: {
    display: "inline-block",
    padding: "6px 10px",
    borderRadius: 999,
    border: "1px solid rgba(15,23,42,0.10)",
    background: "rgba(255,255,255,0.9)",
    fontSize: 12,
    fontWeight: 900,
    color: "#0f172a",
    textTransform: "uppercase",
  },
  grid: {
    maxWidth: 980,
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12,
  },
  card: {
    position: "relative",
    textAlign: "left",
    padding: 16,
    borderRadius: 18,
    border: "1px solid rgba(15,23,42,0.10)",
    background: "rgba(255,255,255,0.92)",
    boxShadow: "0 14px 35px rgba(15, 23, 42, 0.06)",
    cursor: "pointer",
  },
  icon: { fontSize: 22, marginBottom: 10 },
  cardTitle: { fontSize: 14, fontWeight: 950, color: "#0f172a" },
  cardSub: {
    marginTop: 4,
    fontSize: 12,
    fontWeight: 800,
    color: "rgba(15,23,42,0.60)",
  },
  lock: {
    position: "absolute",
    right: 12,
    top: 12,
    fontSize: 11,
    fontWeight: 900,
    padding: "4px 8px",
    borderRadius: 999,
    border: "1px solid rgba(255,75,205,0.22)",
    background: "rgba(255,75,205,0.08)",
    color: "#0f172a",
  },
  note: {
    maxWidth: 980,
    margin: "14px auto 0",
    padding: 12,
    borderRadius: 16,
    border: "1px solid rgba(15,23,42,0.08)",
    background: "rgba(255,255,255,0.8)",
    fontSize: 12,
    fontWeight: 800,
    color: "rgba(15,23,42,0.75)",
  },
};
